(function ($, document, window) {
    $(function () {
        var modalName = window.localStorage.getItem('openmodal');
        if (modalName) {
            var modalObject = $('#' + modalName);
            if (modalObject.length > 0) {
                modalObject.modal();
                window.localStorage.removeItem('openmodal');
            }
        }
    });

}(jQuery, document, window));